// Domínios do grupo comExt (comércio exterior) da DPS, exigido na emissão
// quando tribISSQN = "3" (exportação) ou quando há tomador/intermediário no
// exterior. Os valores "00"/"0" de "desconhecido" que aparecem no leiaute
// oficial não entram aqui: só valem no compartilhamento município -> ADN
// NFS-e, não no preenchimento de uma DPS pelo contribuinte.

export const MD_PRESTACAO_OPTIONS = [
  { value: "1", label: "Transfronteiriço" },
  { value: "2", label: "Consumo no Brasil" },
  { value: "3", label: "Movimento temporário de pessoas físicas" },
  { value: "4", label: "Consumo no exterior" },
];

// Vínculo entre prestador e tomador nos termos do art. 23 da Lei 9.430/1996.
export const VINC_PREST_OPTIONS = [
  { value: "0", label: "Sem vínculo" },
  { value: "1", label: "Controlada" },
  { value: "2", label: "Controladora" },
  { value: "3", label: "Coligada" },
  { value: "4", label: "Matriz" },
  { value: "5", label: "Filial/sucursal" },
  { value: "6", label: "Outro vínculo" },
];

// Mecanismos de apoio ao comércio exterior — as listas do prestador e do
// tomador são diferentes (8 e 26 opções), não é o mesmo domínio.
export const MEC_AF_COMEX_P_OPTIONS = [
  { value: "01", label: "Nenhum" },
  { value: "02", label: "ACC — Adiantamento sobre Contrato de Câmbio" },
  { value: "03", label: "ACE — Adiantamento sobre Cambiais Entregues" },
  { value: "04", label: "BNDES-Exim Pós-Embarque — Serviços" },
  { value: "05", label: "BNDES-Exim Pré-Embarque — Serviços" },
  { value: "06", label: "FGE — Fundo de Garantia à Exportação" },
  { value: "07", label: "PROEX Equalização" },
  { value: "08", label: "PROEX Financiamento" },
];

export const MEC_AF_COMEX_T_OPTIONS = [
  { value: "01", label: "Nenhum" },
  { value: "02", label: "Administração pública e representação internacional" },
  {
    value: "03",
    label:
      "Aluguéis e arrendamento mercantil de máquinas, equipamentos, embarcações e aeronaves",
  },
  {
    value: "04",
    label:
      "Arrendamento mercantil de aeronave para empresa de transporte aéreo público",
  },
  { value: "05", label: "Comissão a agentes externos na exportação" },
  {
    value: "06",
    label:
      "Despesas de armazenagem, movimentação e transporte de carga no exterior",
  },
  { value: "07", label: "Eventos FIFA (subsidiária)" },
  { value: "08", label: "Eventos FIFA" },
  {
    value: "09",
    label: "Fretes, arrendamentos de embarcações ou aeronaves e outros",
  },
  { value: "10", label: "Material aeronáutico" },
  { value: "11", label: "Promoção de bens no exterior" },
  { value: "12", label: "Promoção de destinos turísticos brasileiros" },
  { value: "13", label: "Promoção do Brasil no exterior" },
  { value: "14", label: "Promoção de serviços no exterior" },
  { value: "15", label: "RECINE" },
  { value: "16", label: "RECOPA" },
  { value: "17", label: "Registro e manutenção de marcas, patentes e cultivares" },
  { value: "18", label: "REICOMP" },
  { value: "19", label: "REIDI" },
  { value: "20", label: "REPENEC" },
  { value: "21", label: "REPES" },
  { value: "22", label: "RETAERO" },
  { value: "23", label: "RETID" },
  { value: "24", label: "Royalties, assistência técnica, científica e assemelhados" },
  {
    value: "25",
    label: "Serviços de avaliação da conformidade vinculados aos Acordos da OMC",
  },
  { value: "26", label: "ZPE — Zona de Processamento de Exportação" },
];

// "2" exige nDI e proíbe nRE; "3" exige nRE e proíbe nDI; "1" proíbe os dois.
export const MOV_TEMP_BENS_OPTIONS = [
  { value: "1", label: "Não" },
  { value: "2", label: "Vinculada a Declaração de Importação" },
  { value: "3", label: "Vinculada a Declaração de Exportação" },
];

export const MDIC_OPTIONS = [
  { value: "0", label: "Não enviar" },
  { value: "1", label: "Enviar" },
];

// Motivo de ausência de NIF, para tomador/intermediário no exterior sem
// identificação fiscal.
export const C_NAO_NIF_OPTIONS = [
  { value: "1", label: "Dispensado do NIF" },
  { value: "2", label: "Não exigência do NIF" },
];

// tpMoeda aceita qualquer código de 3 dígitos da tabela de moedas do Banco
// Central — a lista abaixo é só sugestão para o autocomplete, não um domínio
// fechado. O código alfa (ISO 4217) é o que o usuário reconhece; o numérico
// é só o que a DPS exige no payload.
export const MOEDAS_SUGERIDAS = [
  { numerico: "986", alfa: "BRL", nome: "Real brasileiro" },
  { numerico: "840", alfa: "USD", nome: "Dólar dos Estados Unidos" },
  { numerico: "978", alfa: "EUR", nome: "Euro" },
  { numerico: "826", alfa: "GBP", nome: "Libra esterlina" },
  { numerico: "392", alfa: "JPY", nome: "Iene japonês" },
  { numerico: "756", alfa: "CHF", nome: "Franco suíço" },
  { numerico: "124", alfa: "CAD", nome: "Dólar canadense" },
  { numerico: "036", alfa: "AUD", nome: "Dólar australiano" },
  { numerico: "554", alfa: "NZD", nome: "Dólar neozelandês" },
  { numerico: "156", alfa: "CNY", nome: "Yuan renminbi" },
  { numerico: "344", alfa: "HKD", nome: "Dólar de Hong Kong" },
  { numerico: "702", alfa: "SGD", nome: "Dólar de Cingapura" },
  { numerico: "410", alfa: "KRW", nome: "Won sul-coreano" },
  { numerico: "356", alfa: "INR", nome: "Rupia indiana" },
  { numerico: "784", alfa: "AED", nome: "Dirham dos Emirados Árabes Unidos" },
  { numerico: "376", alfa: "ILS", nome: "Novo shekel israelense" },
  { numerico: "949", alfa: "TRY", nome: "Lira turca" },
  { numerico: "643", alfa: "RUB", nome: "Rublo russo" },
  { numerico: "752", alfa: "SEK", nome: "Coroa sueca" },
  { numerico: "578", alfa: "NOK", nome: "Coroa norueguesa" },
  { numerico: "208", alfa: "DKK", nome: "Coroa dinamarquesa" },
  { numerico: "032", alfa: "ARS", nome: "Peso argentino" },
  { numerico: "152", alfa: "CLP", nome: "Peso chileno" },
  { numerico: "170", alfa: "COP", nome: "Peso colombiano" },
  { numerico: "484", alfa: "MXN", nome: "Peso mexicano" },
  { numerico: "604", alfa: "PEN", nome: "Sol peruano" },
  { numerico: "858", alfa: "UYU", nome: "Peso uruguaio" },
  { numerico: "600", alfa: "PYG", nome: "Guarani paraguaio" },
  { numerico: "068", alfa: "BOB", nome: "Boliviano" },
  { numerico: "710", alfa: "ZAR", nome: "Rand sul-africano" },
  { numerico: "973", alfa: "AOA", nome: "Kwanza angolano" },
  { numerico: "943", alfa: "MZN", nome: "Metical moçambicano" },
];

export const MD_PRESTACAO_VALUES = MD_PRESTACAO_OPTIONS.map((o) => o.value);
export const VINC_PREST_VALUES = VINC_PREST_OPTIONS.map((o) => o.value);
export const MEC_AF_COMEX_P_VALUES = MEC_AF_COMEX_P_OPTIONS.map((o) => o.value);
export const MEC_AF_COMEX_T_VALUES = MEC_AF_COMEX_T_OPTIONS.map((o) => o.value);
export const MOV_TEMP_BENS_VALUES = MOV_TEMP_BENS_OPTIONS.map((o) => o.value);
export const MDIC_VALUES = MDIC_OPTIONS.map((o) => o.value);
export const C_NAO_NIF_VALUES = C_NAO_NIF_OPTIONS.map((o) => o.value);
